import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { AppContainer } from "react-hot-loader";
import App from "./App";
import "./index.css";

// disabling service worker
//import registerServiceWorker from "./registerServiceWorker";

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <HashRouter>
        <App />
      </HashRouter>
    </AppContainer>,
    document.getElementById("root")
  );
};

// disabling service worker
//registerServiceWorker();

render(App);

if (module.hot) {
  module.hot.accept("./App", () => {
    render(App);
  });
}


// WEBPACK FOOTER //
// ./src/index.js